import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import { menu, videoPlayer, instagramFeed, ageGate } from './alpine-functions.js';

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.data('menu', menu);
Alpine.data('videoPlayer', videoPlayer);
Alpine.data('instagramFeed', instagramFeed);
Alpine.data('ageGate', ageGate);

Alpine.start();
